import { render } from "./ProjectsListContainer.vue?vue&type=template&id=0592bbbf&scoped=true"
import script from "./ProjectsListContainer.vue?vue&type=script&lang=js"
export * from "./ProjectsListContainer.vue?vue&type=script&lang=js"

import "./ProjectsListContainer.vue?vue&type=style&index=0&id=0592bbbf&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0592bbbf"]])

export default __exports__